import axios from "axios";
import type { GetServerSideProps, InferGetServerSidePropsType } from "next";

import { BreadCrumb } from "@/components/BreadCrumb";
import type {
    GetCategoryDto,
} from "@/entities/types/entities";
import { PageLayout } from "@/layouts/PageLayout";
import Build from "@/shared/assests/fc_background.webp";
import { Routes } from "@/shared/constants";
import { API_BASE } from "@/shared/constants/private";
import { BuildingPage } from "@/view/Building/Building";

export default function Building({ sectionId, sectionNumber, cat }: InferGetServerSidePropsType<typeof getServerSideProps>) {
    const items = [{ label: "Реклама в фитнес клубах" }];

    return (
        <PageLayout
            title="Реклама в фитнес-клубах СПБ | Размещение в спортивных залах"
            description="Эффективная реклама в фитнес-клубах: лайтбоксы, видеомониторы, стикеры. Целевая аудитория - активные люди 18-45 лет. Гибкие условия размещения!"
        >
            <BreadCrumb model={items} />
            <BuildingPage
                sectionId={sectionId}
                sectionNumber={sectionNumber}
                listCategory={cat}
                alt="FITNESS"
                src={Build}
                url={Routes.POSTERFITNES}
                title="Реклама в фитнес клубах"
                description="Спорт — это привычка, а привычки формируют выбор. Реклама в фитнес центрах идеально работает: она появляется перед глазами аудитории, которая стремится к изменениям и готова действовать."
            />
        </PageLayout>
    );
}
export const getServerSideProps: GetServerSideProps = async () => {
    const sectionId = "a5e39d7f-d3d3-4c07-9547-6744b03db681";
    const sectionNumber = 4;

    const resCat = await axios<GetCategoryDto[]>(`${API_BASE}/category`, {
        params: { sectionId: sectionId, onlyPublished: true } }).catch(() => ({ data: [] }))

    return {
        props: {
            sectionId: sectionId,
            sectionNumber: sectionNumber,
            cat: resCat.data,
        },
    };
};
